export const CME = { name: 'CME', type: 'cme', code: 'CME' };
export const NFA = { name: 'NFA', type: 'nfa', code: 'NFA' };
export const BOTH = { name: 'BOTH', type: 'both', code: 'BOTH' };
